import BreadcrumbComp from "@components/UI/Breadcrumb/Index";
import Associacao from "./Associacao";

function ComplianceSection({ solicitacaoFields, loading, error }) {
    const NumeroSolicitacao = solicitacaoFields?.numeroSolicitacao;
    const NomeForm = "Compliance Associado a Solicitação";

    return (
        <div className="row">
            <BreadcrumbComp Param1="Home" Param2="Solicitações e Pêndencias" Param3={`Solicitação ${NumeroSolicitacao}`} />
            <div className="col-12 col-md-12">
                <div className="block h-auto">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 col-md-6 d-flex align-items-center">
                                <h2 className="mb-0">{NomeForm}</h2>
                            </div>

                            <div className="col-12 col-md-6 d-flex align-items-center justify-content-end">
                                <button className="btn btn-menu" type='button'>
                                    <i className="fa-solid fa-bars"></i>
                                </button>
                            </div>

                            <Associacao
                                complianceFields={solicitacaoFields?.compliance}
                                etapaProcesso={solicitacaoFields?.etapaProcesso}
                                loading={loading}
                                error={error}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ComplianceSection;